import { render, staticRenderFns } from "./customerManagement.vue?vue&type=template&id=8b8b40f6&scoped=true&"
import script from "./customerManagement.vue?vue&type=script&lang=js&"
export * from "./customerManagement.vue?vue&type=script&lang=js&"
import style0 from "./customerManagement.vue?vue&type=style&index=0&id=8b8b40f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8b40f6",
  null
  
)

export default component.exports